"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "contact-block" };
const _hoisted_2 = { class: "gdpr-label" };
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = { class: "book-button-block" };
const _hoisted_5 = { class: "img-block" };
const CustomInput_vue_1 = __importDefault(require("../../../components/frontend/CustomInput.vue"));
const Form_1 = require("../../../components/Form");
const CustomButton_vue_1 = __importDefault(require("../../../components/frontend/CustomButton.vue"));
const bookAppointmentStore_1 = require("../../../stores/bookAppointment/bookAppointmentStore");
const CompanyStore_1 = require("../../../stores/company/CompanyStore");
const Alert_vue_1 = __importDefault(require("../../../components/Alert.vue"));
const vue_3 = require("vue");
const vue_router_1 = require("vue-router");
exports.default = (0, vue_1.defineComponent)({
    __name: 'Contact',
    setup(__props) {
        const T = (0, vue_3.inject)("Translator");
        const route = (0, vue_router_1.useRoute)();
        const router = (0, vue_router_1.useRouter)();
        const errorMessage = (0, vue_3.ref)("");
        const bookAppointmentStore = (0, bookAppointmentStore_1.useBookAppointmentStore)();
        const companyStore = (0, CompanyStore_1.useCompanyStore)();
        companyStore.getCompany();
        //T?.trans(
        const gdprHTML = (0, vue_3.computed)(() => {
            return T === null || T === void 0 ? void 0 : T.trans("gdpr", 'I accept the <a target="_blank" href="{pdfUrl}">Privacy Policy </a> and expressly consent to the processing of my personal data by {company} for its own purposes and to its staff contacting me at one of the contact details provided.', "frontend_contact_block", {
                company: companyStore.name,
                pdfUrl: companyStore.pdfUrl ? companyStore.pdfUrl : "#",
            });
        });
        const onNameInput = (e) => {
            bookAppointmentStore.personDatas.name = e.target.value;
        };
        const onPhoneInput = (e) => {
            bookAppointmentStore.personDatas.phoneNumber = e.target.value;
        };
        const onGdprInput = (e) => {
            bookAppointmentStore.personDatas.GDPR = e.target.checked;
        };
        function submitDatas() {
            bookAppointmentStore
                .saveAppointment()
                .then(() => {
                sessionStorage.clear();
                const redirect = router.resolve(route.query.redirect
                    ? `${route.query.redirect}`
                    : { name: "frontend_thankyou" });
                if (redirect.name) {
                    router.replace({ name: redirect.name });
                    return;
                }
                if (redirect.path) {
                    router.replace(redirect.path);
                    return;
                }
                router.replace(redirect);
            })
                .catch((error) => {
                errorMessage.value = error.toString();
            });
        }
        const onAlertDismissed = () => {
            errorMessage.value = "";
        };
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (0, vue_2.createElementVNode)("div", _hoisted_1, [
                    (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                        class: "input-box",
                        label: _ctx.$trans('name', 'Name', 'frontend_contact_block'),
                        name: "name",
                        "max-length": 45,
                        onInput: onNameInput
                    }, null, 8, ["label"]),
                    (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                        class: "input-box",
                        label: _ctx.$trans('phone', 'Phone number', 'frontend_contact_block'),
                        "max-length": 20,
                        name: "tel",
                        onInput: onPhoneInput
                    }, null, 8, ["label"]),
                    (0, vue_2.createElementVNode)("label", _hoisted_2, [
                        (0, vue_2.createVNode)(CustomInput_vue_1.default, {
                            type: "checkbox",
                            name: "gdpr",
                            onInput: onGdprInput
                        }),
                        (0, vue_2.createElementVNode)("div", {
                            class: "text",
                            innerHTML: gdprHTML.value
                        }, null, 8, _hoisted_3)
                    ])
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_4, [
                    (errorMessage.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Alert_vue_1.default, {
                            key: 0,
                            message: errorMessage.value,
                            icon: "",
                            dismissable: "",
                            onDismissed: onAlertDismissed
                        }, null, 8, ["message"]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (0, vue_2.withDirectives)((0, vue_2.createVNode)(CustomButton_vue_1.default, {
                        type: "red",
                        class: "",
                        onPressed: submitDatas
                    }, {
                        default: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createElementVNode)("div", _hoisted_5, (0, vue_2.toDisplayString)(_ctx.$trans("make_reservation_button", "Make reservation", "frontend_contact_block")), 1)
                        ]),
                        _: 1
                    }, 512), [
                        [vue_2.vShow, !errorMessage.value]
                    ])
                ])
            ], 64));
        };
    }
});
